import React from 'react';
import { formatPhoneNumber } from '../utils/FormatData';

const PhoneRenderer = (props) => {

  if (props.value) {
    return (
      <div>
        {formatPhoneNumber(props.value)}
      </div>
    );
  } else {
    return props.value;
  }

};

export default PhoneRenderer;